import React, { useState } from 'react'
import T from 'prop-types'
import Button from 'components/Button'
import Message from 'components/Message'

import getGenderText from '../../helpers/getGenderText'
import Step from '../../components/Step'

export default function Symptoms({ changeStep, values }) {
  const [symptoms, setSymptoms] = useState(undefined)

  const handleChange = (value) => () => {
    setSymptoms(value)
  }

  const title = getGenderText('Har %s noen symptomer på infeksjon nå?', values)

  return (
    <Step
      title={title}
      onSubmit={changeStep}
      submit="Gå videre"
      submitDisabled={symptoms !== false}
      info="Det er anbefalt å vente litt med å ta vaksine om man har feber over 38°C, eller viser andre tydelige infeksjonstegn som tung pust, luftveissymptomer eller generelt redusert allmenntilstand."
    >
      <Button
        key="yes"
        inline
        small
        onClick={handleChange(true)}
        selected={symptoms === true}
      >
        Ja, har symptomer
      </Button>
      <Button
        key="no"
        inline
        small
        onClick={handleChange(false)}
        selected={symptoms === false}
      >
        Nei, har ingen symptomer
      </Button>
      {symptoms === true && (
        <Message type="notice">
          Du bør vente med å ta vaksine til du er helt fri for symptomer. God
          bedring og velkommen tilbake senere.
        </Message>
      )}
    </Step>
  )
}

Symptoms.propTypes = {
  changeStep: T.func.isRequired,
  values: T.object.isRequired,
  onChange: T.func.isRequired,
}
